module.exports = __webpack_public_path__ + "media/images/landing/studies/nestle-01787fd4460079c75c3897fa8953819b.png";